export const LOG_IN = "LOG_IN";
export const SIGN_OUT = "SIGN_OUT";